export default {
  en: {
    'nav.phone': '+358 12 345 6789',
    'nav.email': 'info@example.com',
    'nav.address': 'Address 1, 00000, Helsinki',
    'nav.home': 'Home',
    'nav.catalog': 'Catalog',
    'nav.products': 'Products',
    'nav.dashboard': 'Dashboard',
    'nav.login': 'Log In',
    'nav.signup': 'Sign Up',
    'nav.logout': 'Logout',
    'sidenav.dashboard': 'Dashboard',
    'sidenav.AddNewCompany': 'Add a New Company',
    'sidenav.AddNewProduct': 'Add a New Product',
    'sidenav.EditProfile': 'Edit profile',
    'sidenav.Review': 'Review',
    'sidenav.LogOut': 'Log Out',
    'footer.about': 'Link',
    'footer.about.us': 's',
    'footer.home': 'Home',
    'footer.catalog': 'Catalog',
    'footer.contact': 'Contact',
    'footer.contact.info': 'Info',
    'footer.address': 'Address 1, 00000, Helsinki',
    'footer.phone': '+358 12 345 6789',
    'footer.email': 'info@example.com',
    'footer.copyright': 'Copyright © Agileo ',
    'category.SelectCategory': 'Select Category',
    'category.Agriculture': 'Agriculture, forestry and fishing',
    'category.Industrial': 'Industrial',
    'category.Electricity': 'Electricity, gas and heat supply, refrigeration business',
    'category.Water': 'Water supply, sewerage, waste management and remediation activities',
    'category.Construction': 'Construction',
    'category.Wholesale': 'Wholesale and retail trade',
    'category.Shipping': 'Shipping and storage',
    'category.Accommodation': 'Accommodation and food service activities',
    'category.Information': 'Information and communication',
    'category.Financial': 'Financial and insurance activities',
    'category.Realestate': 'Real estate activities',
    'category.Professional': 'Professional, scientific and technical activities',
    'category.Administrative': 'Administrative and support service activities',
    'category.Public': 'Public administration and defense; compulsory social security',
    'category.Training': 'Training',
    'category.Health': 'Health and social services',
    'category.Arts': 'Arts, entertainment and recreation',
    'category.Other': 'Other service activities',
    'category.unknown': 'Industry unknown',
    'productCategory.SelectCategory': 'Select Product Type',
    'productCategory.Product': 'Product',
    'productCategory.Service': 'Service',
    'productCategory.Accommodation': 'Accommodation',
    'catalog.title': 'Catalog - City Name',
    'catalog.catalog': 'Companies',
    'catalog.searchforacompany': 'Search',
    'catalog.learnmore': 'Learn More',
    'catalog.filter': 'Category',
    'catalog.Nocompaniesfound': 'No companies found...',
    'catalog.phone': 'Tel.',
    'catalog.email': 'Email',
    'catalog.www': 'www',
    'banner.home': 'Home',
    'home.title': 'Home - City Name',
    'home.firstline': 'Qui labore nisi',
    'home.secondline':
      'Search or Publish Companies, Services, Places, Products, Experiences in',
    'home.button': 'Catalog',
    'home.searchInCatalog': 'Search',
    'home.posio': 'Companies, Services, Products, Places in',
    'home.servicesAndCompanies': 'Qui labore nisi',
    'home.catalog': 'Catalog',
    'home.catalogParagraph':
      'Et quis sit tempor cillum reprehenderit irure laboris Lorem. Consequat aute incididunt do nostrud ipsum occaecat irure duis adipisicing culpa adipisicing commodo quis.',
    'home.catalogButton': 'Catalog',
    'home.product': 'Product',
    'home.productParagraph':
      'Et sint irure Lorem irure. Anim ullamco veniam ad eu excepteur in magna eu sunt. Esse do ut excepteur aute est dolor anim do consequat elit deserunt ullamco.',
    'home.productButton': 'Product',
    'login.title': 'Login - City Name',
    'login.login': 'Login',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.ForgotPassword': 'Forgot Password?',
    'login.Donthaveanaccount': "Don't have an account?",
    'signup.title': 'Sign Up - City Name',
    'signup.register': 'Register',
    'signup.CreateYouraccount': 'Create Your account',
    'signup.YourName': 'Your Name',
    'signup.Email': 'Email',
    'signup.YourPhone': 'Your Phone',
    'signup.Password': 'Password',
    'signup.RetypePassword': 'Retype Password',
    'signup.ForgotPassword': 'Forgot Password?',
    'signup.Alreadyhaveanaccount': 'Already have an account?',
    'signup.SignIn': 'Sign In',
    'dashboard.title': 'Dashboard',
    'dashboard.dashboard': 'Dashboard',
    'dashboard.yourcompanies': 'Your Companies',
    'dashboard.yourproducts': 'Your Products',
    'dashboard.addnewcompany': 'Add New Company',
    'dashboard.addnewproduct': 'Add New Product',
    'dashboard.underreview': 'Under Review - wait for email',
    'dashboard.published': 'Published',
    'dashboard.phone': 'Tel.',
    'dashboard.email': 'Email',
    'dashboard.www': 'www',
    'dashboard.company': 'Company',
    'dashboard.name': 'Name',
    'dashboard.category': 'Category',
    'dashboard.label': 'Label',
    'dashboard.languages': 'Languages',
    'dashboard.outfit': 'Outfit',
    'dashboard.duration': 'Duration of service',
    'dashboard.hours': 'hours',
    'dashboard.groupsize': 'Group size',
    'dashboard.price': 'Price',
    'dashboard.place': 'Place',
    'dashboard.startdate': 'Available from',
    'dashboard.enddate': 'Available to',
    'dashboard.edit': 'Edit',
    'dashboard.nocompanies':
      'You have not yet setup a company, please add required info.',
    'createcompany.title': 'Create New Company',
    'createcompany.addnewcompany': 'Add a New Company',
    'createcompany.companyname': 'Name',
    'createcompany.EnterYourCompanyName': 'Enter Your Company Name',
    'createcompany.category': 'Category',
    'createcompany.secondaryCategory': 'Choose a Secondary Category',
    'createcompany.CompanyField': "Company's main Activities in Finnish",
    'createcompany.CompanyFieldEn': "Company's main Activities in English",
    'createcompany.EnterYourCompanyField': 'Short description in Finnish',
    'createcompany.EnterYourCompanyFieldEn': 'Short description in English',
    'createcompany.BusinessID': 'Business ID',
    'createcompany.EnterYourBusinessID': 'E.g. 1234567-8',
    'createcompany.PhoneNumber': 'Phone Number',
    'createcompany.PhoneNumberExample': 'E.g. 040 123 4567',
    'createcompany.EmailAddress': 'Email',
    'createcompany.EmailAddressExample': 'E.g. example@domain.fi',
    'createcompany.CompanyAddress': 'Company Address',
    'createcompany.EnterYourCompanyAddress': 'E.g. Address 1, ',
    'createcompany.CompanyWebsite': 'Website',
    'createcompany.EnterYourCompanyWebsite': 'E.g. www.company.fi',
    'createcompany.CompanyDescription': 'Company Description in Finnish',
    'createcompany.CompanyDescriptionEn': 'Company Description in English',
    'createcompany.Writeaboutyourcompany':
      'Write description about your Company in Finnish',
    'createcompany.WriteaboutyourcompanyEn':
      'Write description about your Company in English',
    'createcompany.photo': 'Image',
    'createcompany.optimalsize': 'Optimal Photo size: 1280 x 720',
    'createcompany.Uploadyourimage': 'Upload Your image',
    'createcompany.URLtoyourTwitter': 'URL to your Twitter',
    'createcompany.URLtoyourFacebook': 'URL to your Facebook',
    'createcompany.URLtoyourInstagram': 'URL to your Instagram',
    'createcompany.URLtoyourYoutube': 'URL to your Youtube',
    'editcompany.title': 'Edit Company - City Name',
    'editcompany.editcompany': 'Edit Company',
    'editcompany.savecompany': 'Save',
    'editcompany.cancelcompany': 'Cancel',
    'editcompany.deletecompany': 'Delete',
    'editcompany.Uploadyourimage': 'Upload Your image',
    'editprofile.title': 'Edit Profile - City Name',
    'editprofile.editprofile': 'Edit Profile',
    'editprofile.Yourname': 'Name',
    'editprofile.EnterYourName': 'First name Last name',
    'editprofile.YourEmail': 'Email',
    'editprofile.EnterYourEmail': 'Enter Your Email',
    'editprofile.Phonenumber': 'Phone number',
    'editprofile.EnterYourphone': 'Enter Your phone',
    'editprofile.Avatar': 'Photo',
    'editprofile.Uploadyouravatar': 'Upload Your picture',
    'editprofile.Changepassword': 'Change password',
    'editprofile.areyousure': 'Are you sure? You will be logged out.',
    'changepassword.title': 'Change Password - City Name',
    'changepassword.changepassword': 'Change Password',
    'changepassword.OldPassword': 'Old Password',
    'changepassword.EnterOldPassword': 'Enter Old Password',
    'changepassword.NewPassword': 'New Password',
    'changepassword.EnterNewPassword': 'Enter New Password',
    'changepassword.RetypePassword': 'Retype Password',
    'changepassword.EnterRetypePassword': 'Retype Password',
    'company.titleLoading': 'Loading... - City Name',
    'company.title': '- City Name',
    'company.CompanyDescription': 'Company Description',
    'company.Summary': 'Summary',
    'company.Category': 'Category:',
    'company.secondaryCategory': 'Secondary category:',
    'company.Phone': 'Phone',
    'company.Email': 'Email:',
    'company.www': 'www',
    'company.BusinessID': 'Business ID',
    'company.LocationOnMap': 'Location On the Map',
    'company.Products': "Company's products",
    'company.YourEmail': 'Your Email *',
    'company.YourPhone': 'Your Phone *',
    'company.YourMessage': 'Your Message *',
    'company.SendMessage': 'Send Message',
    'company.SocialMedia': 'Social Media',
    'company.EditThisCompany': 'Edit This Company',
    'company.emailSuccess': 'Your message has been successfully sent',
    'forgotpassword.title': 'Forgot Password - City Name',
    'forgotpassword.titleSuccess': 'Email has been sent - City Name',
    'forgotpassword.forgotpassword': 'Forgot Password',
    'forgotpassword.Email': 'Email',
    'forgotpassword.RequestNewPassword': 'Request New Password',
    'forgotpassword.Donthaveanaccount': "Don't have an account?",
    'forgotpassword.Checkyourinbox': 'Check your email inbox.',
    'forgotpassword.firstLine':
      'An email has been sent to your email address. It can take a few minutes before you have it in your email inbox.',
    'forgotpassword.secondLine':
      'Follow the link in the email to reset your password.',
    'resetpassword.title': 'Reset Password - City Name',
    'resetpassword.resetpassword': 'Reset Password',
    'resetpassword.NewPassword': 'New Password',
    'resetpassword.EnterNewPassword': 'Enter New Password',
    'resetpassword.RetypePassword': 'Retype Password',
    'resetpassword.EnterRetypePassword': 'Retype Password',
    'resetpassword.SetNewPassword': 'Set New Password',
    'review.title': 'Review - City Name',
    'review.reviewcompanies': 'Review Companies',
    'review.CompaniesforReview': 'Companies for Review',
    'review.ProductsforReview': 'Products for Review',
    'review.phone': 'Tel.',
    'review.email': 'Email',
    'review.www': 'www',
    'review.View': 'View',
    'review.Edit': 'Edit',
    'review.Publish': 'Publish',
    'review.Delete': 'Delete',
    'review.NoCompany': 'No company for review.',
    'review.NoProducts': 'No product for review.',
    'settings.settings': 'Admin Settings',
    'settings.infos': 'Explanations for fields',
    'settings.homeImages': 'Home Images',
    'settings.uploadhomeImage': 'Upload home image',
    'settings.title': 'Settings - City Name',
    'settings.addNewAdmin': 'Add New Admin',
    'settings.adminList': 'Admin List',
    'settings.submit': 'Submit',
    'createproduct.title': 'Create New Product - City Name',
    'createproduct.addnewproduct': 'Add a new Product',
    'createproduct.company': 'Company',
    'createproduct.productType': 'Product Type',
    'createproduct.category': 'Category',
    'createproduct.selectCompany': 'Select Company',
    'createproduct.titlefi': 'Product name (Finnish)',
    'createproduct.entertitlefi': 'Enter product name in Finnish',
    'createproduct.titleen': 'Product name (English)',
    'createproduct.entertitleen': 'Enter product name in English',
    'createproduct.buylink': 'Link for buy button',
    'createproduct.enterbuylink': 'Enter link for buy button',
    'createproduct.labelfi': 'Label (Finnish)',
    'createproduct.enterlabelfi': "Enter product's label in Finnish",
    'createproduct.labelen': 'Label (English)',
    'createproduct.enterlabelen': "Enter product's label in English",
    'createproduct.languagesfi': 'Languages (Finnish)',
    'createproduct.enterlanguagesfi': "Enter product's languages in Finnish",
    'createproduct.languagesen': 'Languages (English)',
    'createproduct.enterlanguagesen': "Enter product's languages in English",
    'createproduct.outfitfi': 'Suitable outfit (Finnish)',
    'createproduct.enteroutfitfi':
      "Enter product's suitable outfits in Finnish",
    'createproduct.outfiten': 'Suitable outfit (English)',
    'createproduct.enteroutfiten':
      "Enter product's suitable outfits in English",
    'createproduct.duration': 'Duration of service in hours',
    'createproduct.enterduration': 'Enter duration of service in hours',
    'createproduct.groupsize': 'Maximum group size',
    'createproduct.entergroupsize': "Enter product's maximum group size",
    'createproduct.pricefi': 'Price (Finnish)',
    'createproduct.enterpricefi': "Free",
    'createproduct.priceen': 'Price (English)',
    'createproduct.enterpriceen': "Free",
    'createproduct.placefi': 'Place (Finnish)',
    'createproduct.enterplacefi': "Enter product's place in Finnish",
    'createproduct.placeen': 'Place (English)',
    'createproduct.enterplaceen': "Enter product's place in English",
    'createproduct.startdate': 'Available from',
    'createproduct.enterstartdate': 'Enter availability start date',
    'createproduct.enddate': 'Available to',
    'createproduct.enterenddate': 'Enter availability end date',
    'createproduct.descriptionfi': 'Description (Finnish)',
    'createproduct.enterdescriptionfi':
      "Enter product's description in Finnish",
    'createproduct.descriptionen': 'Description (English)',
    'createproduct.enterdescriptionen':
      "Enter product's description in English",
    'createproduct.PhoneNumber': 'Phone Number',
    'createproduct.PhoneNumberExample': 'E.g. 040 123 4567',
    'createproduct.EmailAddress': 'Email',
    'createproduct.EmailAddressExample': 'E.g. example@domain.fi',
    'createproduct.CompanyAddress': 'Company Address',
    'createproduct.EnterYourCompanyAddress': 'E.g. Address 1, 00000, Helsinki',
    'createproduct.CompanyWebsite': 'Website',
    'createproduct.EnterYourCompanyWebsite': 'E.g. www.company.fi',
    'createproduct.noCompanies': 'You have to create company first!',
    'createproduct.photo': 'Image',
    'createproduct.optimalsize': 'Optimal Image size: 1280 x 720',
    'createproduct.usecompanyscontacts': "Use company's contacts:",
    'editproduct.title': 'Edit Product - City Name',
    'editproduct.editproduct': 'Edit Product',
    'editproduct.saveproduct': 'Save',
    'editproduct.deleteproduct': 'Delete',
    'editproduct.cancelproduct': 'Cancel',
    'products.title': 'Products - City Name.fi',
    'products.Noproductsfound': 'No products found...',
    'products.products': 'Products',
    'product.contacts': 'Contacts',
    'product.EditThisProduct': 'Edit this product',
    'product.title': ' - City Name.fi',
    'product.ProductDescription': "Product's description",
    'product.phone': 'Phone:',
    'product.email': 'Email:',
    'product.address': 'Address:',
    'product.website': 'Website:',
    'product.when': 'When:',
    'product.whenexplanation': 'Dates of your interest',
    'product.message': 'Message:',
    'product.searchPosio': 'Search for apartments:',
    'product.buylink': 'Buy',
    'product.free': 'Free',
    'product.learnmore': 'Learn More',
    'blank.title': 'Under construction - City Name.fi',
    'blank.underConstuction': 'Under construction',
    'blank.paragraph': 'This page is under constuction',
  },
  fi: {
    'category.SelectCategory': 'Valitse toimiala',
    'category.Agriculture': 'Maatalous, metsätalous ja kalatalous',
    'category.Mining': 'Kaivostoiminta ja louhinta',
    'category.Industrial': 'Teollisuus',
    'category.Electricity': 'Sähkö, kaasu- ja lämpöhuolto, jäähdytysliiketoiminta',
    'category.Water': 'Vesihuolto, viemäri- ja jätevesihuolto, jätehuolto ja muu ympäristön puhtaanapito',
    'category.Construction': 'Rakentaminen',
    'category.Wholesale': 'Tukku- ja vähittäiskauppa',
    'category.Shipping': 'Kuljetus ja varastointi',
    'category.Accommodation': 'Majoitus- ja ravitsemistoiminta',
    'category.Information': 'Informaatio ja viestintä',
    'category.Financial': 'Rahoitus- ja vakuutustoiminta',
    'category.Realestate': 'Kiinteistöalan toiminta',
    'category.Professional': 'Ammatillinen, tieteellinen ja tekninen toiminta',
    'category.Administrative': 'Hallinto- ja tukipalvelutoiminta',
    'category.Public': 'Julkinen hallinto ja maanpuolustus; pakollinen sosiaalivakuutus',
    'category.Training': 'Koulutus',
    'category.Health': 'Terveys- ja sosiaalipalvelut',
    'category.Arts': 'Taiteet, viihde ja virkistys',
    'category.Other': 'Muu palvelutoiminta',
    'category.unknown': 'Toimiala tuntematon',
    'productCategory.SelectCategory': 'Valitse Tuotetyyppi',
    'productCategory.Product': 'Tuote',
    'productCategory.Service': 'Palvelu',
    'productCategory.Accommodation': 'Majoitus',
    'nav.phone': '012 345 6789',
    'nav.email': 'info@example.com',
    'nav.address': 'Address 1, 00000, Helsinki',
    'nav.home': 'Koti',
    'nav.catalog': 'Hakemisto',
    'nav.products': 'Tuotteet',
    'nav.dashboard': 'Työtila',
    'nav.login': 'Kirjaudu sisään',
    'nav.signup': 'Rekisteröidy',
    'nav.logout': 'Kirjaudu ulos',
    'sidenav.dashboard': 'Työtila',
    'sidenav.AddNewCompany': 'Lisää yritys',
    'sidenav.AddNewProduct': 'Lisää uusi tuote',
    'sidenav.EditProfile': 'Muokkaa profiilia',
    'sidenav.Review': 'Julkaise yritys tai tuote',
    'sidenav.LogOut': 'Kirjaudu ulos',
    'footer.about': 'Sivuston',
    'footer.about.us': 'navigointi',
    'footer.home': 'Etusivu',
    'footer.catalog': 'Hakemisto',
    'footer.contact': 'Yhteys',
    'footer.contact.info': 'tiedot',
    'footer.address': 'Address 1, 00000, Helsinki',
    'footer.phone': '040 8012 205',
    'footer.email': 'info@example.com',
    'footer.copyright': 'Copyright © Agileo ',
    'catalog.title': 'Hakemisto - City Name',
    'catalog.catalog': 'Yritys- ja palveluhakemisto',
    'catalog.searchforacompany': 'Etsi',
    'catalog.learnmore': 'Lisätietoja',
    'catalog.filter': 'Rajaa etsintää',
    'catalog.Nocompaniesfound': 'Yrityksiä ei löytynyt...',
    'catalog.phone': 'P.',
    'catalog.email': 'Sähköposti',
    'catalog.www': 'www',
    'banner.home': 'Etusivu',
    'home.title': 'Etusivu - City Name',
    'home.firstline': 'Dolore ullamco velit',
    'home.secondline':
      'Etsi tai julkaise yrityksiä, palveluita, vierailukohteita, tuotteita, elämyksiä...',
    'home.button': 'Hakemisto',
    'home.searchInCatalog': 'Etsi',
    'home.posio': 'Dolore ullamco velit',
    'home.servicesAndCompanies': 'Yritykset ja palvelut',
    'home.catalog': 'Hakemisto',
    'home.catalogParagraph':
      'Proident Lorem est eiusmod laborum magna elit nulla laboris Lorem excepteur irure quis ad proident. Incididunt sint culpa nulla consectetur eu qui labore esse amet. Esse elit laboris enim non commodo sint id irure ad et duis qui.',
    'home.catalogButton': 'Hakemisto',
    'home.product': 'Tuotteet',
    'home.productParagraph':
      'Aliqua cupidatat ullamco magna sint occaecat. Lorem ut ea fugiat voluptate ut labore eu tempor consectetur dolor sunt. Velit elit pariatur qui in exercitation nulla velit officia consectetur laborum do irure dolore enim. Ea sunt ex do officia. Sit qui pariatur et sint enim tempor qui magna. Excepteur voluptate dolor dolor deserunt incididunt labore aute mollit laborum consequat minim Lorem nisi et.',
    'home.productButton': 'Tuotteet',
    'login.title': 'Kirjaudu - City Name',
    'login.login': 'Kirjaudu sisään',
    'login.email': 'Sähköposti',
    'login.password': 'Salasana',
    'login.ForgotPassword': 'Salasana unohtui?',
    'login.Donthaveanaccount': 'Ei vielä kirjautumistiliä?',
    'signup.title': 'Rekisteröidy - City Name',
    'signup.register': 'Rekisteröidy',
    'signup.CreateYouraccount': 'Luo tili',
    'signup.YourName': 'Nimi',
    'signup.Email': 'Sähköposti',
    'signup.YourPhone': 'Puhelinnumero',
    'signup.Password': 'Salasana',
    'signup.RetypePassword': 'Uudelleenkirjoita salasana',
    'signup.ForgotPassword': 'Salasana unohtui?',
    'signup.Alreadyhaveanaccount': 'Kirjautumistili jo olemassa?',
    'signup.SignIn': 'Kirjaudu',
    'dashboard.title': 'Työtila - City Name',
    'dashboard.dashboard': 'Tilitiedot',
    'dashboard.yourcompanies': 'Yrityksesi',
    'dashboard.yourproducts': 'Sinun tuotteesi',
    'dashboard.addnewcompany': 'Lisää uusi yritys',
    'dashboard.addnewproduct': 'Lisää uusi tuote',
    'dashboard.underreview': 'Varmistetaan - odota sähköpostia',
    'dashboard.published': 'Julkaistu',
    'dashboard.phone': 'P.',
    'dashboard.email': 'Sähköposti',
    'dashboard.www': 'www',
    'dashboard.company': 'Yritys',
    'dashboard.name': 'Nimi',
    'dashboard.category': 'Toimiala',
    'dashboard.label': 'Tuotetyyppi',
    'dashboard.languages': 'Kielet',
    'dashboard.outfit': 'Ulkoasu',
    'dashboard.duration': 'Palvelun kesto',
    'dashboard.hours': 'Tuntia',
    'dashboard.groupsize': 'Ryhmän koko',
    'dashboard.price': 'Hinta',
    'dashboard.place': 'Tapahtumapaikka',
    'dashboard.startdate': 'Saatavilla alkaen',
    'dashboard.enddate': 'Saatavilla asti',
    'dashboard.edit': 'Muokkaa',
    'dashboard.nocompanies':
      'Yritystä ei ole vielä perustettu, täydennä vielä tietojasi.',
    'createcompany.title': 'Luo uusi yritys - City Name',
    'createcompany.addnewcompany': 'Lisää uusi yritys',
    'createcompany.companyname': 'Yrityksen nimi',
    'createcompany.EnterYourCompanyName': 'Yrityksen toiminimi',
    'createcompany.category': 'Toimiala',
    'createcompany.secondaryCategory': 'Toissijainen toimiala',
    'createcompany.CompanyField': 'Päätoimiala suomeksi',
    'createcompany.CompanyFieldEn': 'Päätoimiala englanniksi',
    'createcompany.EnterYourCompanyField': 'Muut toimialat suomeksi',
    'createcompany.EnterYourCompanyFieldEn': 'Muut toimialat englanniksi',
    'createcompany.BusinessID': 'Yrityksen y-tunnus',
    'createcompany.EnterYourBusinessID': 'Muodossa: 1234567-8',
    'createcompany.PhoneNumber': 'Puhelinnumero',
    'createcompany.PhoneNumberExample': 'Muodossa: 040 123 4567',
    'createcompany.EmailAddress': 'Sähköposti',
    'createcompany.EmailAddressExample': 'Muodossa: info@yritys.fi',
    'createcompany.CompanyAddress': 'Katu- ja postiosoite',
    'createcompany.EnterYourCompanyAddress':
      'Muodossa: Address 1, 00000, Helsinki',
    'createcompany.CompanyWebsite': 'www-sivut',
    'createcompany.EnterYourCompanyWebsite': 'Muodossa: www.yritys.fi',
    'createcompany.CompanyDescription': 'Yrityksen kuvaus suomeksi',
    'createcompany.CompanyDescriptionEn':
      'Yrityksen kuvaus englanniksi',
    'createcompany.Writeaboutyourcompany':
      'Kuvaa yritystä sen pääpalveluita laajemmin suomeksi',
    'createcompany.WriteaboutyourcompanyEn':
      'Kuvaa yritystä sen pääpalveluita laajemmin englanniksi',
    'createcompany.photo': 'Kuva',
    'createcompany.optimalsize': 'Optimaalinen kuvan koko: 1280 x 720 pikseliä',
    'createcompany.Uploadyourimage': 'Lataa kuvasi',
    'createcompany.URLtoyourTwitter': 'Twitter',
    'createcompany.URLtoyourFacebook': 'Facebook',
    'createcompany.URLtoyourInstagram': 'Instagram',
    'createcompany.URLtoyourYoutube': 'Youtube',
    'editcompany.title': 'Muokkaa - City Name',
    'editcompany.editcompany': 'Muokkaa yritystä',
    'editcompany.savecompany': 'Tallenna',
    'editcompany.cancelcompany': 'Peruuta',
    'editcompany.deletecompany': 'Poista yritys',
    'editcompany.Uploadyourimage': 'Lataa kuvasi',
    'editprofile.title': 'Muokkaa kirjautumisprofiilia - City Name',
    'editprofile.editprofile': 'Muokkaa profiilia',
    'editprofile.Yourname': 'Nimi',
    'editprofile.EnterYourName': 'Muodossa: Etunimi Sukunimi',
    'editprofile.YourEmail': 'Sähköpostiosoite',
    'editprofile.EnterYourEmail': 'Muodossa: info@yritys.fi',
    'editprofile.Phonenumber': 'Puhelinnumero',
    'editprofile.EnterYourphone': 'Muodossa: 040 123 4567',
    'editprofile.Avatar': 'Kuva',
    'editprofile.Uploadyouravatar': 'Lataa kuvasi',
    'editprofile.Changepassword': 'Vaihda salasana',
    'editprofile.areyousure': 'Oletko varma? Sinut kirjataan ulos',
    'changepassword.title': 'Vaihda nykyinen salasana - City Name',
    'changepassword.changepassword': 'Vaihda salasana',
    'changepassword.OldPassword': 'Vanha salasana',
    'changepassword.EnterOldPassword': 'Kirjoita vanha salasana',
    'changepassword.NewPassword': 'Uusi salasana',
    'changepassword.EnterNewPassword': 'Kirjoita uusi salasana',
    'changepassword.RetypePassword': 'Uudelleenkirjoita salasana',
    'changepassword.EnterRetypePassword': 'Uudelleenkirjoita uusi salasana',
    'company.titleLoading': 'Ladataan... - City Name',
    'company.title': '- City Name',
    'company.CompanyDescription': 'Yrityksen kuvaus',
    'company.Summary': 'Työtila',
    'company.Category': 'Toimiala',
    'company.secondaryCategory': 'Toissijainen toimiala',
    'company.Phone': 'Puhelinnumero',
    'company.Email': 'Sähköposti',
    'company.www': 'www',
    'company.BusinessID': 'Y-tunnus',
    'company.LocationOnMap': 'Sijainti kartalla',
    'company.Products': 'Yrityksen tuotteet',
    'company.YourEmail': 'Sähköposti *',
    'company.YourPhone': 'Puhelinnumero *',
    'company.YourMessage': 'Viestisi *',
    'company.SendMessage': 'Lähetä viesti',
    'company.SocialMedia': 'Sosiaalinen media',
    'company.EditThisCompany': 'Muokkaa yrityksen tietoja',
    'company.emailSuccess': 'Viestisi on lähetetty',
    'forgotpassword.title': 'Salasana on unohtunut - City Name',
    'forgotpassword.titleSuccess': 'Sähköposti on lähetetty - City Name',
    'forgotpassword.forgotpassword': 'Salasana unohtunut',
    'forgotpassword.Email': 'Sähköposti',
    'forgotpassword.RequestNewPassword': 'Pyydä uutta salasanaa',
    'forgotpassword.Donthaveanaccount': 'Ei vielä kirjautumistiliä?',
    'forgotpassword.Checkyourinbox': 'Tarkista sähköpostisi',
    'forgotpassword.firstLine':
      'Sähköpostiviesti on lähetetty antamaasi sähköpostiosoitteeseen. Se pitäisi olla sähköpostissasi muutaman minuutin sisällä.',
    'forgotpassword.secondLine':
      'Klikkaa sähköpostiviestissä olevaa linkkiä, jotta pääset vaihtamaan salasanasi.',
    'resetpassword.title': 'Vaida salasana - City Name',
    'resetpassword.resetpassword': 'Vaihda salasana',
    'resetpassword.NewPassword': 'Uusi salasana',
    'resetpassword.EnterNewPassword': 'Kirjoita uusi salasana',
    'resetpassword.RetypePassword': 'Uudelleenkirjoita salasana',
    'resetpassword.EnterRetypePassword': 'Uudelleenkirjoita uusi salasana',
    'resetpassword.SetNewPassword': 'Aseta uusi salasana',
    'review.title': 'Varmista yrityksiä - City Name',
    'review.reviewcompanies': 'Varmista yrityksiä',
    'review.CompaniesforReview': 'Yrityksiä varmistettavana.',
    'review.ProductsforReview': 'Palveluita varmistettavana.',
    'review.phone': 'P.',
    'review.email': 'Sähköposti',
    'review.www': 'www',
    'review.View': 'Tarkista',
    'review.Edit': 'Muokkaa',
    'review.Publish': 'Julkaise',
    'review.Delete': 'Poista',
    'review.NoCompany': 'Ei yrityksiä katselmoitavana.',
    'review.NoProducts': 'Ei tuotteita katselmoitavana.',
    'settings.settings': 'Pääkäyttäjän asetukset',
    'settings.infos': 'Explanations for fields',
    'settings.homeImages': 'Etusivun kuvat',
    'settings.uploadhomeImage': 'Lataa kotisivun kuva',
    'settings.title': 'Asetukset - City Name',
    'settings.addNewAdmin': 'Lisää uusi pääkäyttäjä',
    'settings.adminList': 'Pääkäyttäjät',
    'settings.submit': 'Lähetä',
    'createproduct.title': 'Luo uusi tuote - City Name',
    'createproduct.addnewproduct': 'Lisää uusi tuote',
    'createproduct.company': 'Yritys',
    'createproduct.productType': 'Tuotetyyppi',
    'createproduct.category': 'Tuotetyyppi',
    'createproduct.selectCompany': 'Valitse yritys',
    'createproduct.titlefi': 'Tuotteen nimi',
    'createproduct.entertitlefi': 'Tuotteen nimi suomeksi',
    'createproduct.titleen': 'Product name',
    'createproduct.entertitleen': 'Product name in English',
    'createproduct.buylink': 'Linkki mistä osto/lisätietoa',
    'createproduct.enterbuylink': 'Ostolinkki',
    'createproduct.labelfi': 'Tuotetyyppi',
    'createproduct.enterlabelfi': 'Tuotteen tyyppi suomeksi',
    'createproduct.labelen': 'Product type',
    'createproduct.enterlabelen': 'Product type in English',
    'createproduct.languagesfi': 'Kielet',
    'createproduct.enterlanguagesfi': 'Tuotteen kielet suomeksi',
    'createproduct.languagesen': 'Languages',
    'createproduct.enterlanguagesen': 'Product languages in English',
    'createproduct.outfitfi': 'Tarvittavat varusteet',
    'createproduct.enteroutfitfi': 'Kuvaile tarvittavat varusteet suomeksi',
    'createproduct.outfiten': 'Needed gears',
    'createproduct.enteroutfiten': 'Describe needed gears in English',
    'createproduct.duration': 'Palvelun kesto tunneissa',
    'createproduct.enterduration': 'Palvelun kesto tunneissa',
    'createproduct.groupsize': 'Suurin ryhmän koko',
    'createproduct.entergroupsize': 'Palvelussa sallittu suurin ryhmän koko',
    'createproduct.pricefi': 'Hinta',
    'createproduct.enterpricefi': 'Ilmainen',
    'createproduct.priceen': 'Price',
    'createproduct.enterpriceen': 'Free',
    'createproduct.placefi': 'Osoite',
    'createproduct.enterplacefi': 'Osoite suomeksi',
    'createproduct.placeen': 'Address',
    'createproduct.enterplaceen': 'Address in English',
    'createproduct.startdate': 'Saatavilla alkaen',
    'createproduct.enterstartdate':
      'Aloituspäivämäärä jolloin palvelu on saatavilla',
    'createproduct.enddate': 'Saatavilla asti',
    'createproduct.enterenddate':
      'Lopetuspäivämäärä johon asti palvelu on saatavilla',
    'createproduct.descriptionfi': 'Kuvaus',
    'createproduct.enterdescriptionfi': 'Tuotteen kuvaus suomeksi',
    'createproduct.descriptionen': 'Description',
    'createproduct.enterdescriptionen': 'Product description in English',
    'createproduct.PhoneNumber': 'Puhelinnumero',
    'createproduct.PhoneNumberExample': 'Esim. 040 123 4567',
    'createproduct.EmailAddress': 'Sähköposti',
    'createproduct.EmailAddressExample': 'Esim. esim@yritysnimi.fi',
    'createproduct.CompanyAddress': 'Yrityksen osoite',
    'createproduct.EnterYourCompanyAddress': 'Esim. Address 1, 00000, Helsinki',
    'createproduct.CompanyWebsite': 'Verkkosivu',
    'createproduct.EnterYourCompanyWebsite': 'Esim. www.yritysnimi.fi',
    'createproduct.noCompanies': 'Ensin pitää olla yritys luotuna!',
    'createproduct.photo': 'Kuva',
    'createproduct.optimalsize': 'Optimaalinen kuvan koko: 1280 x 720 pikseliä',
    'createproduct.usecompanyscontacts': 'Käytä yrityksen yhteystietoja:',
    'editproduct.title': 'Muokkaa tuotetta - City Name',
    'editproduct.editproduct': 'Muokkaa tuotetta',
    'editproduct.saveproduct': 'Tallenna',
    'editproduct.deleteproduct': 'Poista',
    'editproduct.cancelproduct': 'Peruuta',
    'products.title': 'Tuotteet - City Name.fi',
    'products.Noproductsfound': 'Ei löytynyt tuotteita hakukriteereillä...',
    'products.products': 'Tuotteet',
    'product.contacts': 'Yhteystiedot',
    'product.EditThisProduct': 'Muokkaa tuotetta',
    'product.title': ' - City Name.fi',
    'product.ProductDescription': 'Tuotteen kuvaus',
    'product.phone': 'Puhelinnumero:',
    'product.email': 'Sähköpostiosoite:',
    'product.address': 'Osoite:',
    'product.website': 'Verkkosivu:',
    'product.when': 'Milloin:',
    'product.whenexplanation': 'Päivämäärät joita viestisi koskee.',
    'product.message': 'Viesti:',
    'product.searchPosio': 'Etsi huoneistoja:',
    'product.buylink': 'Osta',
    'product.free': 'Ilmainen',
    'product.learnmore': 'Tutustu tuotteeseen',
    'blank.title': 'Osio työn alla - City Name.fi',
    'blank.underConstuction': 'Osio työn alla',
    'blank.paragraph': 'Tämä osio on työn alla',
  },
};
